import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import { CheckboksPanelGruppe } from "./../../";
import Alertstripe from "./../../../nav-frontend-alertstriper";
import Lenke from "./../../../nav-frontend-lenker";
export const _frontmatter = {
  "ingress": "Denne komponenten bør benyttes hvis brukeren må utføre en viktig flervalgsoppgave som fortjener større plass på skjermen."
};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const Example = makeShortcode("Example");
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <nav {...{
      "className": "table-of-contents"
    }}><ol parentName="nav" {...{
        "className": "toc-level toc-level-1"
      }}><li parentName="ol" {...{
          "className": "toc-item toc-item-h2"
        }}><a parentName="li" {...{
            "className": "toc-link toc-link-h2",
            "href": "#normal"
          }}>{`Normal`}</a></li><li parentName="ol" {...{
          "className": "toc-item toc-item-h2"
        }}><a parentName="li" {...{
            "className": "toc-link toc-link-h2",
            "href": "#feilmelding"
          }}>{`Feilmelding`}</a><ol parentName="li" {...{
            "className": "toc-level toc-level-2"
          }}><li parentName="ol" {...{
              "className": "toc-item toc-item-h3"
            }}><a parentName="li" {...{
                "className": "toc-link toc-link-h3",
                "href": "#feilmelding-uten-propagering-av-feil-prop-til-children"
              }}>{`Feilmelding uten propagering av feil-prop til children`}</a></li></ol></li></ol></nav>
    <h2 {...{
      "id": "normal"
    }}>{`Normal`}</h2>
    <Example mdxType="Example">
  <CheckboksPanelGruppe legend={"Velg en eller flere:"} checkboxes={[{
        label: "Eplejuice",
        value: "juice1",
        id: "juice1id-1"
      }, {
        label: "Appelsinjuice",
        value: "juice2",
        id: "juice2id-1"
      }, {
        label: "Melk",
        value: "melk",
        disabled: true,
        id: "melkid-1"
      }, {
        label: "Ananasjuice",
        value: "juice3",
        id: "juice4id-1",
        subtext: "Subtext example"
      }]} onChange={() => {}} mdxType="CheckboksPanelGruppe" />
    </Example>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`<CheckboksPanelGruppe
  legend={"Velg en eller flere:"}
  checkboxes={[
    { label: "Eplejuice", value: "juice1", id: "juice1id" },
    { label: "Appelsinjuice", value: "juice2", id: "juice2id" },
    { label: "Melk", value: "melk", disabled: true, id: "melkid" },
    {
      label: "Ananasjuice",
      value: "juice3",
      id: "juice4id",
      subtext: "Subtext example",
    },
  ]}
  onChange={() => {}}
/>
`}</code></pre>
    <Alertstripe type="info" mdxType="Alertstripe">
  Komponenten bør som regel inneholde minst to svaralternativer. Hvis det kun er
  ett svaralternativ bør man heller bruke en{" "}
  <Lenke href="/components/checkbox" mdxType="Lenke">vanlig sjekkboks</Lenke>.
    </Alertstripe>
    <h2 {...{
      "id": "feilmelding"
    }}>{`Feilmelding`}</h2>
    <Example mdxType="Example">
  <CheckboksPanelGruppe legend={"Velg en eller flere:"} checkboxes={[{
        label: "Eplejuice",
        value: "juice1",
        id: "juice1id-2"
      }, {
        label: "Appelsinjuice",
        value: "juice2",
        id: "juice2id-2"
      }, {
        label: "Melk",
        value: "melk",
        disabled: true,
        id: "melkid-2"
      }, {
        label: "Ananasjuice",
        value: "juice3",
        id: "juice4id-2",
        subtext: "Subtext example"
      }]} onChange={() => {}} feil="Feilmeldingstekst må gjenta nøkkelord fra label" mdxType="CheckboksPanelGruppe" />
    </Example>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`<CheckboksPanelGruppe
  legend={"Velg en eller flere:"}
  checkboxes={[
    { label: "Eplejuice", value: "juice1", id: "juice1id" },
    { label: "Appelsinjuice", value: "juice2", id: "juice2id" },
    { label: "Melk", value: "melk", disabled: true, id: "melkid" },
    {
      label: "Ananasjuice",
      value: "juice3",
      id: "juice4id",
      subtext: "Subtext example",
    },
  ]}
  onChange={() => {}}
  feil="Feilmeldingstekst må gjenta nøkkelord fra label"
/>
`}</code></pre>
    <h3 {...{
      "id": "feilmelding-uten-propagering-av-feil-prop-til-children"
    }}>{`Feilmelding uten propagering av feil-prop til children`}</h3>
    <p>{`Bruk `}<inlineCode parentName="p">{`utenFeilPropagering`}</inlineCode>{`-propen for å bestemme om `}<inlineCode parentName="p">{`feil`}</inlineCode>{`-propen til `}<inlineCode parentName="p">{`CheckboksPanelGruppe`}</inlineCode>{` skal propageres til children.`}</p>
    <Example mdxType="Example">
  <CheckboksPanelGruppe legend={"Velg en eller flere:"} checkboxes={[{
        label: "Eplejuice",
        value: "juice1",
        id: "juice1id-2"
      }, {
        label: "Appelsinjuice",
        value: "juice2",
        id: "juice2id-2",
        feil: true
      }, {
        label: "Melk",
        value: "melk",
        disabled: true,
        id: "melkid-2"
      }, {
        label: "Ananasjuice",
        value: "juice3",
        id: "juice4id-2",
        subtext: "Subtext example"
      }]} onChange={() => {}} feil="Feilmeldingstekst må gjenta nøkkelord fra label" utenFeilPropagering mdxType="CheckboksPanelGruppe" />
    </Example>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`<CheckboksPanelGruppe
  legend={"Velg en eller flere:"}
  checkboxes={[
    { label: "Eplejuice", value: "juice1", id: "juice1id" },
    { label: "Appelsinjuice", value: "juice2", id: "juice2id", feil: true },
    { label: "Melk", value: "melk", disabled: true, id: "melkid" },
    {
      label: "Ananasjuice",
      value: "juice3",
      id: "juice4id",
      subtext: "Subtext example",
    },
  ]}
  onChange={() => {}}
  feil="Feilmeldingstekst må gjenta nøkkelord fra label"
  utenFeilPropagering
/>
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      